import {
  DEFAULT_PAGE_CONTROL_VALUE,
  isPageControlValue,
  type PageControlValue,
} from "~/components/ui/page-control-values";

export const HOME_PAGE_CONTROL_STORAGE_KEY = "chess:home:selected-page";
export const ADMIN_PAGE_CONTROL_STORAGE_KEY = "chess:admin:selected-page";

function getPageControlStorage(storage?: Storage): Storage | null {
  if (storage) {
    return storage;
  }

  if (typeof window === "undefined") {
    return null;
  }

  return window.localStorage;
}

export function restorePageControlValue(
  storageKey: string,
  storage?: Storage,
): PageControlValue {
  try {
    const storedValue = getPageControlStorage(storage)?.getItem(storageKey);

    if (isPageControlValue(storedValue)) {
      return storedValue;
    }
  } catch {
    return DEFAULT_PAGE_CONTROL_VALUE;
  }

  return DEFAULT_PAGE_CONTROL_VALUE;
}

export function persistPageControlValue(
  storageKey: string,
  value: PageControlValue,
  storage?: Storage,
): void {
  try {
    getPageControlStorage(storage)?.setItem(storageKey, value);
  } catch {
    // localStorage may be unavailable or quota-blocked; selection can remain in memory.
  }
}
